var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import unifiedActivity, { INITIAL_STATE, TYPE_CATEGORIES, DEFAULT_BATCH_SIZE } from '@banking/ui/workflows/unified-activity/unified-activity';
import { tracked } from '@glimmer/tracking';
import { updateLogger } from '@banking/ui/lib/workflow/update-logger';
import { createSelect, createEmit } from '@banking/ui/lib/workflow-ember/decorators';
import connect from '@banking/ui/lib/workflow-ember/connect';
import { formatActivityDetails } from '@banking/ui/utils/activity/detail/formatter';
import BalanceReporterActivity from '@banking/ui/utils/activity/balance-reporter-activity';
import { ActionCreator } from '@banking/ui/workflows/balance';
const SERVICE_REGISTRY_KEY = 'reporter';
let Reporter = (_dec = service('bbfrontend/v1/printable-check'), _dec2 = service('bbfrontend/v1/categories'), _dec3 = service('bbfrontend/v1/card-list-service'), _class = class Reporter extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "features", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "logEvents", _descriptor4, this);
    _initializerDefineProperty(this, "sentry", _descriptor5, this);
    _initializerDefineProperty(this, "balanceReporterApi", _descriptor6, this);
    _initializerDefineProperty(this, "bizbankApi", _descriptor7, this);
    _initializerDefineProperty(this, "transactionServiceApi", _descriptor8, this);
    _initializerDefineProperty(this, "unitBalance", _descriptor9, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor10, this);
    _initializerDefineProperty(this, "dataApi", _descriptor11, this);
    _initializerDefineProperty(this, "bbFrontendV1PrintableCheckService", _descriptor12, this);
    _initializerDefineProperty(this, "bbFrontendV1CategoriesService", _descriptor13, this);
    _initializerDefineProperty(this, "bbFrontendV1CardListService", _descriptor14, this);
    _initializerDefineProperty(this, "state", _descriptor15, this);
    _defineProperty(this, "states", void 0);
    _defineProperty(this, "emit", void 0);
    _defineProperty(this, "updates", void 0);
    const activitiesApi = new BalanceReporterActivity(this.balanceReporterApi, detail => formatActivityDetails(detail, this.intl, this.sentry), this.features);
    const {
      emit,
      states,
      updates
    } = unifiedActivity({
      cancelPrintableCheck: this.bbFrontendV1PrintableCheckService.client.cancelPrintableCheck.bind(this.bbFrontendV1PrintableCheckService.client),
      dataApi: this.dataApi,
      dismissPrintableCheckBlade: () => {
        this.unitBalance.emit(ActionCreator.userClickDismissPrintableCheckBlade());
      },
      downloadCheck: printableCheckId => {
        this.unitBalance.emit(ActionCreator.userClickDownloadCheck(printableCheckId));
      },
      getBootstrapPrintableCheckManagement: this.bbFrontendV1PrintableCheckService.client.bootstrapPrintableCheckManagement.bind(this.bbFrontendV1PrintableCheckService.client),
      getActivities: activitiesApi.getActivities.bind(activitiesApi),
      getActivityDetails: activitiesApi.getActivityDetails.bind(activitiesApi),
      listCategories: this.bbFrontendV1CategoriesService.client.listCategories.bind(this.bbFrontendV1CategoriesService.client),
      logEvents: this.logEvents,
      marketToasts: this.marketToasts,
      printCheck: printableCheckId => {
        this.unitBalance.emit(ActionCreator.userClickPrintCheck(printableCheckId));
      },
      recognizeTransaction: this.transactionServiceApi.overrideDeclinedAuth.bind(this.transactionServiceApi),
      retrieveTransactionAuth: this.transactionServiceApi.retrieveAuthState.bind(this.transactionServiceApi),
      sentry: this.sentry,
      updateCategory: this.bbFrontendV1CategoriesService.client.updateCategory.bind(this.bbFrontendV1CategoriesService.client),
      getCardList: this.bbFrontendV1CardListService.client.getCardList.bind(this.bbFrontendV1CardListService.client),
      translate: key => this.intl.t(key)
    }, {
      config: {
        requireExportLink: true,
        enablePostedBalance: true,
        typeCategories: TYPE_CATEGORIES,
        cardCategories: [],
        activityPageSize: DEFAULT_BATCH_SIZE
      }
    });
    this.emit = emit;
    this.states = states;
    this.updates = updates;
    states.subscribe(state => {
      this.state = state;
    });
    updates.subscribe(updateLogger('Unified Activity'));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "logEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "balanceReporterApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "bizbankApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "transactionServiceApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "unitBalance", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1PrintableCheckService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1CategoriesService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1CardListService", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "state", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return INITIAL_STATE;
  }
}), _class);
export { Reporter as default };
export const select = createSelect(SERVICE_REGISTRY_KEY);
export const emit = createEmit(SERVICE_REGISTRY_KEY);
export const workflowComponent = connect(SERVICE_REGISTRY_KEY);